import type { LayoutDataType } from '../../types';

export const GREETING_OPTIONS: {
  id: NonNullable<LayoutDataType['greeting']>;
  title: string;
}[] = [
  {
    id: 'come_in',
    title: "Come in, the pool's out back.",
  },
  {
    id: 'drink',
    title: 'Need anything first? A drink maybe?',
  },
  {
    id: 'dress',
    title: 'Do you always dress like that for work?',
  },
];
